import {Navbar} from '@common/ui/navigation/navbar/navbar';
import {useUser} from '../use-user';
import {ProgressCircle} from '@common/ui/progress/progress-circle';
import {WishListPanel} from './wish-list-panel/wish-list-panel';
import {Trans} from '@common/i18n/trans';
import {StaticPageTitle} from '@common/seo/static-page-title';

export function AccountWishesPage() {
  const {data, isLoading} = useUser('me', {
    with: ['roles', 'social_profiles', 'tokens'],
  });

  return (
    <div className="min-h-screen bg-alt">
      <StaticPageTitle>
        <Trans message="Account Wishes"/>
      </StaticPageTitle>
      <Navbar menuPosition="account-settings-page"/>

      <div className="px-10 md:px-24 py-24">
        <h1 className="text-3xl">
          <Trans message="MY WISHES"/>
        </h1>
        <div className="mb-40 text-base text-muted">
          <Trans message="View and update your my wishes here."/>
        </div>

        {isLoading || !data ? (
          <ProgressCircle className="my-80" aria-label="Loading Wishes.."
                          isIndeterminate/>
        ) : (
          <main className="break-words">
            <WishListPanel user={data.user}/>
          </main>
        )}
      </div>
    </div>
  );
}

